import axios from 'axios'
import {ConfigEnum} from "@/enums/httpEnum";
import router from '../router'
import {message} from "ant-design-vue";


let baseURL = '';
if (process.env.NODE_ENV === 'production') {
    baseURL = process.env.VUE_APP_DOMAIN_URL;
} else if (process.env.NODE_ENV === 'development') {
    baseURL = JSON.parse(process.env.VUE_APP_PROXY)[0];
}
// 创建axios实例
const request = axios.create({
    baseURL: baseURL,// 所有的请求地址前缀部分(没有后端请求不用写)
    timeout: 1000 * 60, // 请求超时时间(毫秒)
    withCredentials: true,// 异步请求携带cookie
    // headers: {
    // 设置后端需要的传参类型
    // 'Content-Type': 'application/json',
    // 'token': x-auth-token',//一开始就要token
    // 'X-Requested-With': 'XMLHttpRequest',
    // },
})

// request拦截器
request.interceptors.request.use(
    config => {
        config.headers[ConfigEnum.TENANT_ID] = localStorage.getItem(ConfigEnum.TENANT_ID);
        config.headers[ConfigEnum.TOKEN] = localStorage.getItem(ConfigEnum.TOKEN);
        return config
    },
    error => {
        // 对请求错误做些什么
        Promise.reject(error)
    }
)

// response 拦截器
request.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        return response.data
    },
    error => {
        let status = error.response.status;
        switch (status) {
            case 401:
                localStorage.clear();
                router?.push({name: 'login'});
                break;
            case 500:
                message.warning('请求异常');
                break;
            default:
        }
        console.log(error)
        // 对响应错误做点什么
        return error?.response?.data;
    }
)
export default request